function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  id: "Line_102",
  "data-name": "Line 102",
  x2: 4,
  transform: "translate(1 1)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Line_103",
  "data-name": "Line 103",
  x2: 4,
  transform: "translate(1 8)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  id: "Line_104",
  "data-name": "Line 104",
  x2: 4,
  transform: "translate(1 16)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  id: "Line_105",
  "data-name": "Line 105",
  x2: 4,
  transform: "translate(1 22)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  id: "Line_106",
  "data-name": "Line 106",
  x1: 1,
  transform: "translate(1 5)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  id: "Line_107",
  "data-name": "Line 107",
  x1: 1,
  transform: "translate(1 12)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  id: "Line_108",
  "data-name": "Line 108",
  x1: 1,
  transform: "translate(1 18)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_93",
  "data-name": "Rectangle 93",
  width: 12,
  height: 21,
  transform: "translate(10 1)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

function SvgRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "size-large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.aa4c6ef2.svg";
export { ForwardRef as ReactComponent };